import {
  CAR_DATA_MASTER_GET_FINANCIAL_ENTITIES_BEGIN,
  CAR_DATA_MASTER_GET_FINANCIAL_ENTITIES_SUCCESS,
  CAR_DATA_MASTER_GET_FINANCIAL_ENTITIES_FAILURE,
  CAR_DATA_MASTER_GET_FINANCIAL_ENTITIES_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_ABM_FW } from '../../../common/config';
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getFinancialEntities(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CAR_DATA_MASTER_GET_FINANCIAL_ENTITIES_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.get(REACT_APP_API_ABM_FW + "/abms/financial_entity" + args);
      doRequest.then(
        (res) => {
          if (res.data.success) {
            const financial_entities = res.data.data;
            if (financial_entities.length > 0) {
              dispatch({
                type: CAR_DATA_MASTER_GET_FINANCIAL_ENTITIES_SUCCESS,
                data: financial_entities
              });
              resolve(res);
            } else {
              dispatch({
                type: CAR_DATA_MASTER_GET_FINANCIAL_ENTITIES_SUCCESS,
                data: []
              });
              resolve(res);
            }
          } else {
            dispatch({
              type: CAR_DATA_MASTER_GET_FINANCIAL_ENTITIES_FAILURE,
              data: [],
            });
            reject();
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: CAR_DATA_MASTER_GET_FINANCIAL_ENTITIES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetFinancialEntitiesError() {
  return {
    type: CAR_DATA_MASTER_GET_FINANCIAL_ENTITIES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_GET_FINANCIAL_ENTITIES_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getFinancialEntitiesPending: true,
        getFinancialEntitiesError: null,
      };

    case CAR_DATA_MASTER_GET_FINANCIAL_ENTITIES_SUCCESS:
      // The request is success
      return {
        ...state,
        getFinancialEntitiesPending: false,
        getFinancialEntitiesError: null,
        financialEntityList: [...action.data]
      };

    case CAR_DATA_MASTER_GET_FINANCIAL_ENTITIES_FAILURE:
      // The request is failed
      return {
        ...state,
        getFinancialEntitiesPending: false,
        getFinancialEntitiesError: action.data.error,
      };

    case CAR_DATA_MASTER_GET_FINANCIAL_ENTITIES_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getFinancialEntitiesError: null,
      };

    default:
      return state;
  }
}
